import { warmupLambda } from "./warmupLambda";
import { sendEmail } from "./sendMail";

export const sendEmailWithWarmup = async (
  ...args: Parameters<typeof sendEmail>
) => {
  console.log("Warming up Lambda...");
  let warmed = false;
  let attempts = 0;
  const maxAttempts = 10; // Prevent infinite loops

  while (!warmed && attempts < maxAttempts) {
    attempts++;
    console.log(`Lambda warmup attempt ${attempts}/${maxAttempts}...`);

    warmed = await warmupLambda();

    if (!warmed) {
      if (attempts < maxAttempts) {
        console.log("Lambda warmup failed. Waiting 5 seconds before retry...");
        await new Promise((resolve) => setTimeout(resolve, 5000)); // 5 second delay
      } else {
        throw new Error(
          `Lambda warmup failed after ${maxAttempts} attempts. Aborting send.`
        );
      }
    }
  }
  await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 second delay
  console.log("Lambda warmed. Proceeding with send...");
  return await sendEmail(...args);
};
